/* ==========================================================================
   MUNDIAL THEME -- global.js
   Vanilla JS. No dependencies. Loaded with defer.
   ========================================================================== */
(function () {
  'use strict';

  // ------------------------------------------------------------------
  // Utilities
  // ------------------------------------------------------------------
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

  const trapFocus = (container, firstFocus) => {
    const focusable = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    (firstFocus || first).focus();
    container.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  };

  const lockScroll = (lock) => {
    document.documentElement.classList.toggle('no-scroll', lock);
  };

  const fetchJSON = async (url, opts = {}) => {
    const res = await fetch(url, {
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      ...opts,
    });
    return res.json();
  };

  // ------------------------------------------------------------------
  // Sticky Header -- always visible, applies glass effect on scroll
  // ------------------------------------------------------------------
  const header = $('.site-header');
  if (header) {
    let ticking = false;
    const updateHeader = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 80);
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { requestAnimationFrame(updateHeader); ticking = true; }
    }, { passive: true });
  }

  // ------------------------------------------------------------------
  // Mobile Nav
  // ------------------------------------------------------------------
  const mobileNav = $('.mobile-nav');
  const mobileNavToggle = $('.mobile-nav-toggle');
  const mobileNavClose = $('.mobile-nav__close');

  const openMobileNav = () => { mobileNav?.classList.add('is-open'); lockScroll(true); };
  const closeMobileNav = () => { mobileNav?.classList.remove('is-open'); lockScroll(false); };

  mobileNavToggle?.addEventListener('click', openMobileNav);
  mobileNavClose?.addEventListener('click', closeMobileNav);

  // ===========================================================================
  // CART -- rewritten clean
  // Rules:
  //   - taxa-personalizacao is hidden, its price merged into the jersey item
  //   - quantity +/- is debounced (400ms) with optimistic UI update
  //   - removing a jersey also removes its paired fee item
  //   - promotions (Buy X Get Y) are handled natively by Shopify -- no custom logic needed
  // ===========================================================================

  // -- Elements --
  const cartDrawer         = document.getElementById('CartDrawer');
  const cartDrawerBackdrop = document.querySelector('.cart-drawer__backdrop');
  const cartDrawerItems    = document.getElementById('CartDrawerItems');
  const cartDrawerFooter   = document.getElementById('CartDrawerFooter');
  const cartDrawerSubtotal = document.getElementById('CartDrawerSubtotal');
  const cartToggleBtns     = document.querySelectorAll('.cart-toggle, [data-cart-toggle]');
  const cartCloseBtn       = document.querySelector('.cart-drawer__close');

  // -- Open / Close --
  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawerBackdrop && cartDrawerBackdrop.classList.add('is-open');
    document.documentElement.classList.add('no-scroll');
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartDrawerBackdrop && cartDrawerBackdrop.classList.remove('is-open');
    document.documentElement.classList.remove('no-scroll');
  }

  cartToggleBtns.forEach(btn => btn.addEventListener('click', e => {
    e.preventDefault();
    refreshCart().then(openCart);
  }));
  cartCloseBtn && cartCloseBtn.addEventListener('click', closeCart);
  cartDrawerBackdrop && cartDrawerBackdrop.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeCart();
  });

  // -- Fetch + parse JSON preservando precisão de IDs grandes --
  // Shopify usa IDs de variante/produto com 15-19 dígitos, que excedem
  // Number.MAX_SAFE_INTEGER. O JSON.parse nativo do browser converte esses
  // campos para Number e ARREDONDA silenciosamente, trocando o ID por um
  // diferente (ex: variante "M" passa a apontar para outra variante).
  // Esta função converte "id":123456789012345 em "id":"123456789012345"
  // (string) antes do parse, para nunca perder dígitos.
  async function fetchJsonSafe(url) {
    const res = await fetch(url, { headers: { 'Accept': 'application/json' } });
    const text = await res.text();
    const safeText = text.replace(/"id":\s*(\d{16,})/g, '"id":"$1"');
    return JSON.parse(safeText);
  }

  // -- Format money --
  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-PT', {
        style: 'currency',
        currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR'
      }).format(cents / 100);
    } catch(e) {
      return '\u20ac' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }
  window.formatMoney = formatMoney;

  // -- Update cart badge count --
  function updateCartCount(count) {
    document.querySelectorAll('.cart-count-bubble').forEach(el => {
      el.textContent = count > 0 ? count : '';
    });
    // Carrinho flutuante: mostrar/esconder conforme tem itens
    const float = document.getElementById('CartFloat');
    if (float) {
      if (count > 0) float.classList.remove('cart-float--empty');
      else float.classList.add('cart-float--empty');
    }
    // Marca o body (controla a visibilidade anti-flash do botao flutuante)
    if (count > 0) document.body.classList.add('cart-has-items');
    else document.body.classList.remove('cart-has-items');
  }

  function updateCartFloatTotal(cart) {
    const el = document.getElementById('CartFloatTotal');
    if (el) el.textContent = formatMoney(cart.total_price);

    // Label de portes reflete o total REAL -- nunca afirma "Portes Grátis"
    // se o carrinho não atingir o threshold.
    const labelEl = document.getElementById('CartFloatLabel');
    const floatBtn = document.getElementById('CartFloat');
    if (labelEl && floatBtn) {
      const threshold = parseInt(floatBtn.getAttribute('data-free-shipping-threshold'), 10) || 5000;
      labelEl.textContent = cart.total_price >= threshold ? 'Finalizar · Portes Grátis' : 'Finalizar';
    }
  }

  // -- Fetch cart and update drawer --
  async function refreshCart() {
    try {
      let cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());

      // Reconcile gifts FIRST: remove excess free items if entitlement dropped
      // (e.g. user removed paid shirts -> no longer entitled to some gifts)
      try {
        const giftsChanged = await reconcileGifts(cart);
        if (giftsChanged) {
          cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
        }
      } catch(giftErr) {
        console.error('[KICK.X] Gift reconcile error:', giftErr);
      }

      // Reconcile fee on EVERY refresh -- covers all add paths
      // (product form, quick add, native submit, page reload)
      try {
        const changed = await reconcileFee(cart);
        if (changed) {
          cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
        }
      } catch(feeErr) {
        console.error('[KICK.X] Fee reconcile error:', feeErr);
      }

      renderCart(cart);
      return cart;
    } catch(err) {
      console.error('[KICK.X] Cart fetch error:', err);
    }
  }

  // Remove free gift items that exceed current entitlement.
  // Returns true if the cart was changed.
  async function reconcileGifts(cart) {
    let paid = 0;
    const giftLines = []; // { line, qty }
    cart.items.forEach((item, idx) => {
      if (isFeeItem(item)) return;
      if (item.properties && item.properties['_gift'] === 'true') {
        giftLines.push({ line: idx + 1, qty: item.quantity });
      } else {
        paid += item.quantity;
      }
    });

    const totalGifts = giftLines.reduce((s, g) => s + g.qty, 0);
    const entitled = freeForPaid(paid);
    let excess = totalGifts - entitled;
    if (excess <= 0) return false;

    // Remove excess gifts, starting from the LAST gift line added
    let changed = false;
    for (let i = giftLines.length - 1; i >= 0 && excess > 0; i--) {
      const g = giftLines[i];
      const removeQty = Math.min(g.qty, excess);
      const newQty = g.qty - removeQty;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: g.line, quantity: newQty })
      });
      excess -= removeQty;
      changed = true;
      // Note: removing a line shifts subsequent line numbers, but since we go
      // from last to first and re-fetch after, this is safe for one pass.
    }
    return changed;
  }

  // -- Render cart HTML by fetching the liquid snippet --
  async function renderCart(cart) {
    if (!cartDrawerItems) return;

    updateCartCount(cart.item_count);

    // Fetch the server-rendered snippet (handles all fee merging logic in Liquid)
    try {
      const res  = await fetch('/?sections=cart-items');
      const data = await res.json();
      if (data && data['cart-items']) {
        cartDrawerItems.innerHTML = data['cart-items'];
        bindCartControls();
      }
    } catch(err) {
      // Fallback: basic JS render if section fetch fails
      renderCartFallback(cart);
    }

    // Update subtotal & totals
    updateCartTotals(cart);

    // Show/hide footer
    if (cartDrawerFooter) {
      cartDrawerFooter.hidden = cart.item_count === 0;
    }

    // Gift picker (Buy X Get Y)
    updateGiftPicker(cart);

    // Merged promo + free shipping bar (no topo, dentro do gift progress)
    renderFreeShip(cart);

    // Recomendados — cross-sell com seletor de tamanho + personalização
    renderCartRecs(cart);

    // Carrinho vazio: preenche os "Mais Vendidos" dinamicamente (o resto
    // do estado vazio — mensagem de promoção e política — já vem do
    // Liquid, server-rendered, sem precisar de JS).
    if (cart.item_count === 0) {
      renderEmptyCartRecs();
    }
  }

  // -- Atualiza Subtotal / Poupanca / Total + valor no botao --
  function updateCartTotals(cart) {
    const subtotalEl = document.getElementById('CartDrawerSubtotal');
    const discRow    = document.getElementById('CartDrawerDiscountRow');
    const discEl     = document.getElementById('CartDrawerDiscount');
    const totalEl    = document.getElementById('CartDrawerTotal');
    const btnTotalEl = document.getElementById('CartCheckoutTotal');

    // original_total_price = soma sem descontos; total_price = com descontos
    const original = cart.original_total_price != null ? cart.original_total_price : cart.total_price;
    const total    = cart.total_price;
    const savings  = Math.max(0, original - total);

    if (subtotalEl) subtotalEl.textContent = formatMoney(original);
    if (totalEl)    totalEl.textContent    = formatMoney(total);
    if (btnTotalEl) btnTotalEl.textContent = '\u2014 ' + formatMoney(total);

    if (discRow && discEl) {
      if (savings > 0) {
        discEl.textContent = '- ' + formatMoney(savings);
        discRow.hidden = false;
      } else {
        discRow.hidden = true;
      }
    }

    updateCartFloatTotal(cart);
  }

  // ===========================================================================
  // BENEFITS LINE -- portes gratis + promo, fundido na barra de ofertas (topo)
  // Threshold envio gratis: 50 euros (5000 cents). Exclui a taxa.
  // ===========================================================================
  const FREESHIP_THRESHOLD = 5000; // 50 euros em centimos

  function renderFreeShip(cart) {
    // Esta funcao agora injeta uma linha de beneficios DENTRO da barra de
    // ofertas (#CartGiftProgress), para ser um bloco unico e compacto.
    const host = document.getElementById('CartGiftProgress');
    if (!host) return;

    // Soma o valor das camisolas (exclui a taxa de personalizacao)
    let total = 0;
    cart.items.forEach(item => {
      if (!isFeeItem(item)) total += item.final_line_price;
    });

    // Remove linha de beneficios anterior (para nao duplicar)
    const oldLine = host.querySelector('.cart-benefits');
    if (oldLine) oldLine.remove();

    if (total <= 0 || host.hidden) return; // sem itens ou barra escondida

    const freeShip = total >= FREESHIP_THRESHOLD;
    const remaining = FREESHIP_THRESHOLD - total;

    // Constroi os "chips" de beneficio
    let chips = '';
    if (freeShip) {
      chips += benefitChip(true, 'Portes <strong>GR\u00c1TIS</strong>');
    } else {
      chips += benefitChip(false, 'Falta <strong>' + formatMoney(remaining) + '</strong> p/ portes gr\u00e1tis');
    }

    const line = document.createElement('div');
    line.className = 'cart-benefits';
    line.innerHTML = chips;
    host.appendChild(line);

    // Reforça a confirmação junto ao botão "Finalizar Compra" -- só quando
    // for verdade (nunca afirma portes grátis se o total não atingir o
    // threshold). Mesmo total/threshold já calculados acima, sem duplicar
    // lógica nem risco de desalinhamento entre os dois pontos da página.
    const shippingNoteEl = document.getElementById('CartDrawerShippingNote');
    if (shippingNoteEl) {
      if (freeShip) {
        shippingNoteEl.innerHTML = truckSvg() + ' Portes <strong>GRÁTIS</strong> nesta compra';
        shippingNoteEl.classList.add('is-free-shipping');
      } else {
        shippingNoteEl.innerHTML = '&#128274; Pagamento Seguro &bull; Entrega Garantida';
        shippingNoteEl.classList.remove('is-free-shipping');
      }
    }
  }

  function benefitChip(done, text) {
    const ico = done
      ? '<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><path d="M20 6 9 17l-5-5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/><path d="M12 8v4l2.5 2.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    return '<span class="cart-benefits__chip' + (done ? ' is-done' : '') + '">' +
      '<span class="cart-benefits__ico">' + ico + '</span>' + text + '</span>';
  }

  function truckSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" width="16" height="16">' +
      '<path d="M1 3h15v13H1zM16 8h4l3 3v5h-7M5.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM18.5 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  // -- Fallback render (pure JS, no server fetch) --
  function renderCartFallback(cart) {
    if (!cartDrawerItems) return;

    if (cart.item_count === 0) {
      cartDrawerItems.innerHTML = '<div class="cart-drawer__empty"><p>O teu carrinho est\u00e1 vazio.</p><a href="/collections/all" class="btn btn--primary">Ver produtos</a></div>';
      return;
    }

    cartDrawerItems.innerHTML = cart.items.map((item, idx) => {
      const line = idx + 1;

      // Fee line -- compact, no controls
      if (isFeeItem(item)) {
        return `
          <div class="cart-item cart-item--fee-line" data-line="${line}">
            <div class="cart-item__fee-icon">\u270e</div>
            <div class="cart-item__info">
              <span class="cart-item__title">Taxa de Personaliza\u00e7\u00e3o</span>
              ${item.quantity > 1 ? `<div class="cart-item__variant">\u00d7${item.quantity}</div>` : ''}
            </div>
            <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
          </div>`;
      }

      const isFreeGift = item.final_line_price === 0 && item.original_line_price > 0;

      const props = item.properties ? Object.entries(item.properties)
        .filter(([k, v]) => v && !k.startsWith('_') && !k.includes('Personaliza'))
        .map(([k, v]) => `<div class="cart-item__property"><span>${k}:</span> ${v}</div>`)
        .join('') : '';

      const variantHtml = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="cart-item__variant">${item.variant_title}${item.quantity > 1 ? ' \u00b7 \u00d7' + item.quantity : ''}</div>`
        : (item.quantity > 1 ? `<div class="cart-item__variant">\u00d7${item.quantity}</div>` : '');

      let priceHtml;
      if (isFreeGift) {
        priceHtml = `<span class="cart-item__gift-badge">OFERTA</span> <s class="cart-item__price-original">${formatMoney(item.original_line_price)}</s> <span class="cart-item__price-free">${formatMoney(0)}</span>`;
      } else if (item.final_line_price < item.original_line_price) {
        priceHtml = `<s class="cart-item__price-original">${formatMoney(item.original_line_price)}</s> ${formatMoney(item.final_line_price)}`;
      } else {
        priceHtml = formatMoney(item.final_line_price);
      }

      const controlsHtml = isFreeGift ? '' : `
        <div class="cart-item__qty">
          <button type="button" class="cart-item__qty-btn" data-action="minus" data-line="${line}" aria-label="Diminuir">&#8722;</button>
          <input type="number" class="cart-item__qty-input" value="${item.quantity}" min="1" data-line="${line}" aria-label="Quantidade">
          <button type="button" class="cart-item__qty-btn" data-action="plus" data-line="${line}" aria-label="Aumentar">+</button>
        </div>
        <button type="button" class="cart-item__remove" data-line="${line}">Remover</button>`;

      return `
        <div class="cart-item${isFreeGift ? ' cart-item--gift' : ''}" data-line="${line}">
          <a href="${item.url}" class="cart-item__image" tabindex="-1">
            ${item.image ? `<img src="${item.image}" alt="${item.title}" loading="lazy" width="80" height="100">` : ''}
          </a>
          <div class="cart-item__info">
            <a href="${item.url}" class="cart-item__title">${item.product_title}</a>
            ${variantHtml}
            ${props ? `<div class="cart-item__properties">${props}</div>` : ''}
            <div class="cart-item__price">${priceHtml}</div>
          </div>
          <div class="cart-item__controls">${controlsHtml}</div>
        </div>`;
    }).join('');

    bindCartControls();
  }

  // -- Bind quantity and remove controls (by LINE number, not key) --
  // Line numbers are required because Shopify splits lines for Buy X Get Y
  // discounts (paid + free), and split lines can share the same key.
  function bindCartControls() {
    if (!cartDrawerItems) return;

    cartDrawerItems.querySelectorAll('.cart-item__qty-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const line  = parseInt(btn.dataset.line, 10);
        const input = cartDrawerItems.querySelector(`.cart-item__qty-input[data-line="${line}"]`);
        if (!input || !line) return;
        let qty = parseInt(input.value, 10) || 1;
        if (btn.dataset.action === 'plus')  qty = qty + 1;
        if (btn.dataset.action === 'minus') qty = Math.max(1, qty - 1);
        input.value = qty; // optimistic
        scheduleUpdate(line, qty);
      });
    });

    cartDrawerItems.querySelectorAll('.cart-item__qty-input').forEach(input => {
      input.addEventListener('change', () => {
        const line = parseInt(input.dataset.line, 10);
        const qty  = Math.max(1, parseInt(input.value, 10) || 1);
        input.value = qty;
        if (line) scheduleUpdate(line, qty);
      });
    });

    cartDrawerItems.querySelectorAll('.cart-item__remove').forEach(btn => {
      btn.addEventListener('click', () => {
        const line = parseInt(btn.dataset.line, 10);
        if (line) cartItemUpdate(line, 0);
      });
    });
  }

  // -- Debounce quantity updates --
  const _qtTimers = {};
  function scheduleUpdate(line, qty) {
    clearTimeout(_qtTimers[line]);
    _qtTimers[line] = setTimeout(() => cartItemUpdate(line, qty), 400);
  }

  // -- Personalization fee reconciliation --
  // Fee quantity must always equal the TOTAL number of personalized jersey
  // units in the cart (paid + free). No fragile "pairing" logic.
  function isFeeItem(item) {
    return item.handle === 'taxa-personalizacao' ||
           (item.properties && item.properties['_perso_fee'] === 'true');
  }

  function isPersonalized(item) {
    if (isFeeItem(item)) return false;
    const props = item.properties || {};
    return Object.keys(props).some(k => {
      if (k.startsWith('_')) return false;
      const v = props[k];
      return v && String(v).trim() !== '';
    });
  }

  async function reconcileFee(cart) {
    let neededQty = 0;
    let feeLine   = null;
    let feeQty    = 0;

    cart.items.forEach((item, idx) => {
      if (isFeeItem(item)) {
        feeLine = idx + 1; // 1-based
        feeQty  = item.quantity;
      } else if (isPersonalized(item)) {
        neededQty += item.quantity;
      }
    });

    if (feeQty === neededQty) return false; // already correct

    if (feeLine && neededQty === 0) {
      // Remove fee entirely
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: feeLine, quantity: 0 })
      });
      return true;
    }

    if (feeLine) {
      // Adjust fee quantity
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: feeLine, quantity: neededQty })
      });
      return true;
    }

    if (neededQty > 0) {
      // Fee item missing -- add it
      if (!window._kickxFeeVid) {
        const fp = await fetch('/products/taxa-personalizacao.js').then(r => r.ok ? r.json() : null).catch(() => null);
        if (fp && fp.variants && fp.variants[0]) {
          window._kickxFeeVid = fp.variants[0].id;
        } else {
          console.error('[KICK.X] Produto taxa-personalizacao inacessivel -- taxa nao adicionada!');
        }
      }
      if (window._kickxFeeVid) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: window._kickxFeeVid,
            quantity: neededQty,
            properties: { '_perso_fee': 'true' }
          })
        });
        return true;
      }
    }
    return false;
  }

  // -- Update item quantity / remove (quantity 0) by line number --
  async function cartItemUpdate(line, quantity) {
    if (cartDrawerItems) cartDrawerItems.style.opacity = '0.5';
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      await refreshCart(); // reconcilia taxa + re-renderiza
    } catch(err) {
      console.error('[KICK.X] Cart update error:', err);
    } finally {
      if (cartDrawerItems) cartDrawerItems.style.opacity = '';
    }
  }

  // -- Add to cart (product form submit) --  // -- Add to cart (product form submit) --
  document.querySelectorAll('form[data-product-form]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();

      // Validação dos tamanhos do pack: todos os selects têm de estar preenchidos
      const packSelects = form.querySelectorAll('.pack-box__size');
      if (packSelects.length > 0) {
        let missing = null;
        packSelects.forEach(sel => {
          if (!sel.value && !missing) missing = sel;
        });
        if (missing) {
          missing.focus();
          missing.classList.add('pack-box__size--error');
          setTimeout(() => missing.classList.remove('pack-box__size--error'), 1500);
          const box = form.querySelector('#pack-box');
          if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return; // não adiciona enquanto faltarem tamanhos
        }
      }

      const btn = form.querySelector('[type="submit"]');
      const originalText = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'A adicionar...'; }

      try {
        const res  = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
        const data = await res.json();

        if (data.status && data.status !== 200) {
          alert(data.description || 'Erro ao adicionar ao carrinho.');
          return;
        }

        await refreshCart(); // reconcilia taxa automaticamente
        openCart();

      } catch(err) {
        console.error('[KICK.X] Add to cart error:', err);
        alert('Erro ao adicionar ao carrinho. Tenta novamente.');
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = originalText; }
      }
    });
  });

  // ===========================================================================
  // GIFT PICKER -- Buy X Get Y
  // Promos ativas (nao combinam entre si, Shopify escolhe a melhor):
  //   compra 2 leva +1 | compra 3 leva +2 | compra 4 leva +3 | compra 5 leva +4
  // O picker so aparece quando adicionar +1 camisola resulta em mais 1 gratis.
  // Anti-abuso: recalculado a cada render; e mesmo que alguem force o add,
  // o Shopify so desconta se as regras baterem -- senao cobra preco normal.
  // ===========================================================================
  // GIFT PROGRESS + PICKER -- Buy X Get Y
  // Promos ATIVAS (Shopify escolhe a melhor; nao combinam entre si):
  //   compra 2 leva +1  |  compra 4 leva +3  |  compra 5 leva +4
  // (LEVE 5 PAGUE 3 esta expirada -- removida do calculo)
  // A taxa de personalizacao NAO conta (esta fora da colecao do desconto).
  // Anti-abuso: recalculado a cada render; e o Shopify so desconta no
  // checkout se as regras baterem -- senao cobra preco normal.
  // ===========================================================================
  // GIFT PROGRESS + PICKER -- Buy X Get Y
  // Promos ATIVAS (Shopify escolhe a melhor; nao combinam entre si):
  //   PAGA 2 leva +1  |  PAGA 4 leva +3  |  PAGA 5 leva +4
  // (LEVE 5 PAGUE 3 esta expirada -- removida)
  //
  // Logica: o gatilho e o numero de camisolas PAGAS (nao o total).
  //   - pagas  = camisolas normais (sem _gift, sem ser taxa)
  //   - gratis = camisolas adicionadas pelo picker (propriedade _gift=true)
  // A taxa de personalizacao nunca conta.
  // ===========================================================================
  const GIFT_PROMOS = [ [2,1], [4,3], [5,4] ]; // [paga X, leva Y gratis]
  const GIFT_COLLECTION_HANDLE = 'todas-as-camisolas';

  function isGiftItem(item) {
    return item.properties && item.properties['_gift'] === 'true';
  }

  // Quantas gratis o cliente tem DIREITO, dado P camisolas pagas
  function freeForPaid(P) {
    let best = 0;
    GIFT_PROMOS.forEach(([pay, free]) => {
      if (P >= pay) best = Math.max(best, Math.floor(P / pay) * free);
    });
    return best;
  }

  // Conta pagas e gratis no carrinho
  function countCart(cart) {
    let paid = 0, gift = 0;
    cart.items.forEach(item => {
      if (isFeeItem(item)) return;
      if (isGiftItem(item)) gift += item.quantity;
      else paid += item.quantity;
    });
    return { paid: paid, gift: gift };
  }

  // Ofertas ainda disponiveis = direito - ja escolhidas
  function giftSlotsAvailable(cart) {
    const c = countCart(cart);
    return Math.max(0, freeForPaid(c.paid) - c.gift);
  }

  // Proximo gatilho: quantas PAGAS faltam para desbloquear mais oferta(s)
  function nextMilestone(cart) {
    const c = countCart(cart);
    const entitledNow = freeForPaid(c.paid);
    for (let add = 1; add <= 12; add++) {
      if (freeForPaid(c.paid + add) > entitledNow) {
        return { missing: add, paidNow: c.paid, nextPaid: c.paid + add };
      }
    }
    return null;
  }

  let _giftProducts = null;
  async function fetchGiftProducts() {
    if (_giftProducts) return _giftProducts;
    try {
      const data = await fetchJsonSafe('/collections/' + GIFT_COLLECTION_HANDLE + '/products.json?limit=250');
      _giftProducts = (data.products || []).filter(p => p.variants && p.variants.length);
      return _giftProducts;
    } catch(e) {
      console.error('[KICK.X] Gift products fetch error:', e);
      return [];
    }
  }

  // ---- Progress bar ----
  function renderGiftProgress(cart) {
    const bar = document.getElementById('CartGiftProgress');
    if (!bar) return;

    const c = countCart(cart);
    if (c.paid <= 0) { bar.hidden = true; bar.innerHTML = ''; return; }

    const next = nextMilestone(cart);
    const slots = giftSlotsAvailable(cart);

    let html;

    if (slots <= 0 && !next) {
      // Sem oferta ativa nem proxima -- mostra so a linha de beneficios
      bar.classList.remove('gift-progress--unlocked');
      bar.innerHTML = '';
      bar.hidden = false;
      renderFreeShip(cart);
      return;
    }

    if (slots > 0) {
      // Tem oferta(s) por reclamar -- estado de destaque
      bar.classList.add('gift-progress--unlocked');
      html =
          '<div class="gift-progress__top">' +
            '<span class="gift-progress__gift-ico" aria-hidden="true">' + giftSvg() + '</span>' +
            '<span class="gift-progress__msg">' +
              'Desbloqueaste <strong>' + slots + '</strong> camisola' + (slots > 1 ? 's' : '') + ' <strong>GR\u00c1TIS</strong>' +
            '</span>' +
          '</div>' +
          '<div class="gift-progress__track"><div class="gift-progress__fill" style="width:100%"></div></div>' +
          '<div class="gift-progress__hint">Escolhe ' + (slots > 1 ? 'as tuas ofertas' : 'a tua oferta') + ' j\u00e1 a seguir \u2193</div>';
    } else if (next) {
      // A caminho do proximo gatilho
      bar.classList.remove('gift-progress--unlocked');
      const blockStart = next.nextPaid - missingForFirst(next.nextPaid);
      const denom = next.nextPaid - blockStart;
      const num = c.paid - blockStart;
      const pct = denom > 0 ? Math.min(100, Math.max(5, Math.round((num / denom) * 100))) : 0;

      html =
          '<div class="gift-progress__top">' +
            '<span class="gift-progress__gift-ico" aria-hidden="true">' + giftSvg() + '</span>' +
            '<span class="gift-progress__msg">' +
              'Falta' + (next.missing > 1 ? 'm ' : ' ') + '<strong>' + next.missing + '</strong> ' +
              'para <strong>+1 camisola gr\u00e1tis</strong>' +
            '</span>' +
          '</div>' +
          '<div class="gift-progress__track"><div class="gift-progress__fill" style="width:' + pct + '%"></div></div>';
    } else {
      bar.hidden = true; bar.innerHTML = ''; bar.classList.remove('gift-progress--unlocked'); return;
    }

    bar.innerHTML = html;
    bar.hidden = false;

    // Adiciona a linha de beneficios (portes gratis + promo) por baixo
    renderFreeShip(cart);
  }
  function missingForFirst(targetPaid) {
    // encontra a promo cujo gatilho == targetPaid (ou multiplo)
    let span = targetPaid;
    GIFT_PROMOS.forEach(([pay]) => {
      if (targetPaid % pay === 0) span = Math.min(span, pay);
    });
    return span;
  }

  function giftSvg() {
    return '<svg viewBox="0 0 24 24" fill="none" width="18" height="18">' +
      '<path d="M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  // ---- Picker ----
  // ===========================================================================
  // AUTO-CONVERSÃO DE OFERTA -- evita o "engano" de pedir para escolher uma
  // camisola grátis quando o cliente já tem, no carrinho, unidades normais
  // OU personalizadas suficientes para cobrir o BLOCO COMPLETO da oferta
  // (pagas + grátis). Ex: "Paga 2 Leva +1" tem bloco de 3 unidades totais --
  // só converte automaticamente quando o cliente já tem 3 ou mais unidades
  // compráveis no carrinho (porque aí uma delas já "sobra" para ser a
  // grátis). Com exactamente 2 (o mínimo que ativa a oferta), NÃO converte
  // -- continua a mostrar o picker, para o cliente poder optar por adicionar
  // uma 3ª unidade grátis sem perder nenhuma das que já tem como pagas.
  // Para unidades personalizadas, a personalização (nome/número) é
  // preservada -- só o preço passa a €0. Unidades normais (sem
  // personalização) têm prioridade sobre as personalizadas na escolha de
  // qual converter, para o cliente "perder" o mínimo de personalização
  // possível.
  // ===========================================================================
  // Dado um total de unidades que o cliente já tem (compradas, qty total),
  // encontra a melhor divisão (p pagas, g grátis) tal que p+g=total e
  // g <= freeForPaid(p), maximizando g (grátis) -- SEM exigir que o cliente
  // adicione mais nenhuma unidade. Isto é diferente de giftSlotsAvailable,
  // que assume que TODAS as unidades atuais ficam pagas e calcula a oferta
  // sobre isso; aqui resolve-se a melhor redistribuição possível com o que
  // já está no carrinho.
  function bestSplitForTotal(total) {
    let bestG = 0, bestP = total;
    for (let p = 0; p <= total; p++) {
      const g = total - p;
      const maxG = freeForPaid(p);
      if (g <= maxG && g > bestG) { bestG = g; bestP = p; }
    }
    return { paid: bestP, gift: bestG };
  }

  let _autoConvertRunning = false;
  async function autoConvertGiftSlots(cart) {
    if (_autoConvertRunning) return false; // evita corridas concorrentes

    const c = countCart(cart);
    const totalConvertible = c.paid + c.gift; // unidades já no carrinho (compráveis)
    const split = bestSplitForTotal(totalConvertible);

    // Quantas unidades adicionais precisam de passar a grátis para atingir
    // a melhor divisão possível, partindo do estado atual.
    const autoConvertible = split.gift - c.gift;
    if (autoConvertible <= 0) return false; // já está na divisão ótima -- picker normal continua

    let slots = autoConvertible;

    _autoConvertRunning = true;
    try {

      // Linhas elegíveis: não-gift, não-fee, com qty > 0 (normais E
      // personalizadas). Normais primeiro, personalizadas por último --
      // assim só se converte uma personalizada se não houver normais
      // suficientes para cobrir a oferta toda.
      const normalLines = [];
      const personalizedLines = [];
      cart.items.forEach((item, idx) => {
        if (isFeeItem(item) || isGiftItem(item)) return;
        if (item.quantity <= 0) return;
        if (isPersonalized(item)) personalizedLines.push({ line: idx + 1, item: item });
        else normalLines.push({ line: idx + 1, item: item });
      });

      const eligibleLines = normalLines.concat(personalizedLines);
      if (!eligibleLines.length) return false; // nada elegível -- picker normal continua

      let changed = false;

      for (const entry of eligibleLines) {
        if (slots <= 0) break;
        // Re-lê a quantidade atual da linha a cada iteração (pode já ter sido reduzida)
        const currentQty = entry.item.quantity;
        if (currentQty <= 0) continue;

        // 1) Reduz 1 unidade da linha paga
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: entry.line, quantity: currentQty - 1 })
        });
        entry.item.quantity = currentQty - 1;

        // 2) Adiciona essa mesma variante como linha grátis (qty 1),
        //    preservando as properties originais (nome/número) se existirem.
        const giftProps = {};
        const origProps = entry.item.properties || {};
        Object.keys(origProps).forEach(k => {
          if (k.startsWith('_')) return; // ignora props internas (_perso_fee, etc.)
          const v = origProps[k];
          if (v && String(v).trim() !== '') giftProps[k] = v;
        });
        giftProps['_gift'] = 'true';

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: entry.item.variant_id,
            quantity: 1,
            properties: giftProps
          })
        });

        slots -= 1;
        changed = true;
      }

      return changed;
    } catch(e) {
      console.error('[KICK.X] Auto-convert gift slot error:', e);
      return false;
    } finally {
      _autoConvertRunning = false;
    }
  }

  async function updateGiftPicker(cart) {
    // Always use the freshest cart state -- after a removal the passed-in
    // cart can be stale (reconciles may have changed it). Re-fetch to be safe.
    try {
      cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
    } catch(e) { /* fall back to passed cart */ }

    // Antes de mostrar o picker, tenta converter automaticamente unidades já
    // compradas em grátis. Se converteu algo, o carrinho mudou -- relê tudo
    // e re-renderiza do zero para refletir o novo estado.
    const converted = await autoConvertGiftSlots(cart);
    if (converted) {
      try {
        cart = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(r => r.json());
      } catch(e) { /* usa o cart já atualizado localmente */ }
      renderCart(cart);
      return;
    }

    renderGiftProgress(cart);

    const box = document.getElementById('CartGiftPicker');
    if (!box) return;

    const slots = giftSlotsAvailable(cart);
    if (slots <= 0) { box.hidden = true; box.innerHTML = ''; return; }

    const products = await fetchGiftProducts();
    if (!products.length) { box.hidden = true; return; }

    const optionsHtml = products.map((p, i) =>
      '<option value="' + i + '">' + p.title.replace(/</g, '&lt;') + '</option>'
    ).join('');

    box.innerHTML =
      '<div class="cart-gift-picker__inner">' +
        '<div class="cart-gift-picker__title">' +
          '<span class="cart-gift-picker__badge">GR\u00c1TIS</span> ' +
          'Escolhe ' + (slots > 1 ? 'uma das tuas ' + slots + ' ofertas' : 'a tua oferta') +
        '</div>' +
        '<select class="cart-gift-picker__select" id="GiftProductSelect">' +
          '<option value="">Escolhe a camisola</option>' + optionsHtml +
        '</select>' +
        '<select class="cart-gift-picker__select" id="GiftSizeSelect" disabled>' +
          '<option value="">Tamanho</option>' +
        '</select>' +
        '<button type="button" class="btn cart-gift-picker__add" id="GiftAddBtn" disabled>' +
          'Adicionar gr\u00e1tis' +
        '</button>' +
      '</div>';
    box.hidden = false;

    const prodSel = document.getElementById('GiftProductSelect');
    const sizeSel = document.getElementById('GiftSizeSelect');
    const addBtn  = document.getElementById('GiftAddBtn');

    prodSel.addEventListener('change', () => {
      sizeSel.innerHTML = '<option value="">Tamanho</option>';
      addBtn.disabled = true;
      addBtn.classList.remove('is-ready');
      const p = products[parseInt(prodSel.value, 10)];
      if (!p) { sizeSel.disabled = true; return; }
      p.variants.forEach(v => {
        if (v.available === false) return;
        sizeSel.innerHTML += '<option value="' + v.id + '">' + v.title.replace(/</g, '&lt;') + '</option>';
      });
      sizeSel.disabled = false;
    });

    sizeSel.addEventListener('change', () => {
      const ready = !!sizeSel.value;
      addBtn.disabled = !ready;
      addBtn.classList.toggle('is-ready', ready);
    });

    addBtn.addEventListener('click', async () => {
      const vid = sizeSel.value;
      if (!vid) return;
      addBtn.disabled = true;
      addBtn.textContent = 'A adicionar...';
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: vid, quantity: 1, properties: { '_gift': 'true' } })
        });
        await refreshCart();
      } catch(e) {
        console.error('[KICK.X] Gift add error:', e);
        addBtn.disabled = false;
        addBtn.textContent = 'Adicionar gr\u00e1tis';
      }
    });
  }



  // ===========================================================================
  // CART RECOMMENDATIONS -- cross-sell na drawer
  // Mostra 3-4 camisolas que NAO estao ja no carrinho, cada uma com:
  //   - toggle de tamanho (dropdown de pills, so abre uma de cada vez)
  //   - toggle "Personalizar" (nome + numero) para produtos personalizaveis
  //   - botao "+" que adiciona ao carrinho com o tamanho/personalizacao escolhidos
  // Fonte: coleção "todas-as-camisolas" (mesma do gift picker), filtrando o
  // que ja esta no carrinho. Maximo 4 produtos, so reage a mudancas de cart.
  // ===========================================================================
  const CART_RECS_COLLECTION_HANDLE = 'todas-as-camisolas';
  const CART_RECS_MAX = 4;
  const CART_RECS_EMPTY_MAX = 4; // quantos mostrar no estado de carrinho vazio

  let _recsProducts = null;
  async function fetchRecsProducts() {
    if (_recsProducts) return _recsProducts;
    try {
      const data = await fetchJsonSafe('/collections/' + CART_RECS_COLLECTION_HANDLE + '/products.json?limit=250');
      _recsProducts = (data.products || []).filter(p => p.variants && p.variants.length);
      return _recsProducts;
    } catch(e) {
      console.error('[KICK.X] Cart recs fetch error:', e);
      return [];
    }
  }

  // Mais Vendidos reais: usa sort_by=best-selling do Shopify (dados reais
  // de encomendas), nao uma lista escolhida a dedo. Cache própria, separada
  // dos recomendados normais (que usam ordem da coleção/baralhada).
  let _bestSellingProducts = null;
  async function fetchBestSellingProducts() {
    if (_bestSellingProducts) return _bestSellingProducts;
    try {
      const data = await fetchJsonSafe('/collections/' + CART_RECS_COLLECTION_HANDLE + '/products.json?limit=250&sort_by=best-selling');
      _bestSellingProducts = (data.products || []).filter(p => p.variants && p.variants.length);
      return _bestSellingProducts;
    } catch(e) {
      console.error('[KICK.X] Best selling fetch error:', e);
      return [];
    }
  }

  // Deteta se um produto e personalizavel, usando a mesma regra da pagina de
  // produto (tag "personalizavel" ou tipo camisola/jersey/shirt/kit).
  function recIsPersonalizable(product) {
    const tags = (product.tags || []).map(t => String(t).toLowerCase());
    if (tags.indexOf('personalizavel') !== -1) return true;
    const type = (product.product_type || '').toLowerCase();
    return type.indexOf('camisola') !== -1 || type.indexOf('jersey') !== -1 ||
           type.indexOf('shirt') !== -1 || type.indexOf('kit') !== -1;
  }

  function recImageUrl(product) {
    if (product.images && product.images.length) {
      // products.json devolve URLs completos; usamos o primeiro
      return product.images[0].src || product.images[0];
    }
    return '';
  }

  function buildRecCardHtml(p, idx) {
    const variant = p.variants.find(v => v.available) || p.variants[0];
    const price = formatMoney(Math.round(parseFloat(variant.price) * 100));
    const compareAt = variant.compare_at_price ? parseFloat(variant.compare_at_price) : 0;
    const priceCompareHtml = (compareAt > parseFloat(variant.price))
      ? '<span class="cart-rec__price-compare">' + formatMoney(Math.round(compareAt * 100)) + '</span>'
      : '';

    const sizeOptionsHtml = p.variants.map(v => {
      const sizeLabel = (v.title || '').split(' / ').pop();
      return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
        sizeLabel.replace(/</g, '&lt;') + '</option>';
    }).join('');

    const personalizable = recIsPersonalizable(p);
    const productUrl = '/products/' + p.handle;

    return (
      '<div class="cart-rec" data-rec-item data-rec-idx="' + idx + '" data-personalizable="' + personalizable + '">' +
        '<a href="' + productUrl + '" class="cart-rec__image" aria-label="Ver ' + (p.title || '').replace(/</g, '&lt;') + '">' +
          '<img src="' + recImageUrl(p) + '" alt="' + (p.title || '').replace(/</g, '&lt;') + '" loading="lazy" width="100" height="125">' +
        '</a>' +
        (personalizable
          ? '<button type="button" class="cart-rec__perso-toggle" data-rec-perso-toggle aria-expanded="false" aria-label="Personalizar">' +
              '<svg viewBox="0 0 24 24" fill="none" width="12" height="12"><path d="M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</button>'
          : '') +
        '<a href="' + productUrl + '" class="cart-rec__title">' + (p.title || '').replace(/</g, '&lt;') + '</a>' +
        '<div class="cart-rec__price">' + price + priceCompareHtml + '</div>' +
        '<div class="cart-rec__controls">' +
          '<select class="cart-rec__size-select" data-rec-size aria-label="Tamanho">' +
            '<option value="" selected disabled>Tamanho</option>' + sizeOptionsHtml +
          '</select>' +
          '<button type="button" class="cart-rec__add" data-rec-add aria-label="Adicionar ao carrinho" disabled>' +
            '<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
        (personalizable
          ? '<div class="cart-rec__perso-fields" data-rec-perso-fields hidden>' +
              '<input type="text" class="cart-rec__perso-input" data-rec-perso-name placeholder="Nome" maxlength="12" autocomplete="off">' +
              '<input type="number" class="cart-rec__perso-input cart-rec__perso-input--num" data-rec-perso-num placeholder="Nº" min="1" max="99" autocomplete="off">' +
            '</div>'
          : '') +
      '</div>'
    );
  }

  async function renderEmptyCartRecs() {
    const box = document.getElementById('CartEmptyRecs');
    if (!box) return;

    const allProducts = await fetchBestSellingProducts();
    if (!allProducts.length) { box.innerHTML = ''; return; }

    const picks = allProducts.slice(0, CART_RECS_EMPTY_MAX);
    const itemsHtml = picks.map((p, idx) => buildRecCardHtml(p, idx)).join('');

    box.innerHTML = '<div class="cart-recs__list">' + itemsHtml + '</div>';
    bindCartRecsControls(box);
  }

  async function renderCartRecs(cart) {
    const box = document.getElementById('CartRecs');
    if (!box) return;

    if (!cart.items.length) { box.hidden = true; box.innerHTML = ''; return; }

    const allProducts = await fetchRecsProducts();
    if (!allProducts.length) { box.hidden = true; return; }

    // IDs de produto ja no carrinho (para nao recomendar o que ja tem)
    // Normaliza para string de ambos os lados (cart.items vem de /cart.js
    // como Number; allProducts vem com IDs em string por precisão).
    const cartProductIds = new Set(cart.items.map(it => String(it.product_id)));

    const candidates = allProducts.filter(p => !cartProductIds.has(String(p.id)));
    if (!candidates.length) { box.hidden = true; box.innerHTML = ''; return; }

    // Baralha levemente para variar, mantem so CART_RECS_MAX
    const picks = candidates
      .slice()
      .sort(() => Math.random() - 0.5)
      .slice(0, CART_RECS_MAX);

    const itemsHtml = picks.map((p, idx) => buildRecCardHtml(p, idx)).join('');

    box.innerHTML =
      '<div class="cart-recs__title">Recomendados para ti</div>' +
      '<div class="cart-recs__list">' + itemsHtml + '</div>';
    box.hidden = false;

    bindCartRecsControls(box);
  }

  function bindCartRecsControls(box) {
    box.querySelectorAll('[data-rec-item]').forEach(item => {
      const sizeSelect  = item.querySelector('[data-rec-size]');
      const persoToggle = item.querySelector('[data-rec-perso-toggle]');
      const persoFields = item.querySelector('[data-rec-perso-fields]');
      const addBtn      = item.querySelector('[data-rec-add]');

      // -- Tamanho: select nativo, mais compacto que dropdown custom --
      if (sizeSelect) {
        sizeSelect.addEventListener('change', () => {
          addBtn.disabled = !sizeSelect.value;
        });
      }

      // -- Toggle de personalizacao (nome + numero), expande sob o cartao --
      if (persoToggle && persoFields) {
        persoToggle.addEventListener('click', (e) => {
          e.stopPropagation();
          const isOpen = persoToggle.getAttribute('aria-expanded') === 'true';
          persoToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          persoFields.hidden = isOpen;
        });
      }

      // -- Adicionar ao carrinho --
      addBtn.addEventListener('click', async () => {
        const vid = sizeSelect ? sizeSelect.value : '';
        if (!vid) return;
        addBtn.disabled = true;
        const originalSvg = addBtn.innerHTML;
        addBtn.innerHTML = '<span style="font-size:0.6rem;">...</span>';

        const properties = {};
        if (item.dataset.personalizable === 'true') {
          const nameInput = item.querySelector('[data-rec-perso-name]');
          const numInput  = item.querySelector('[data-rec-perso-num]');
          const name = nameInput ? nameInput.value.trim() : '';
          const num  = numInput ? numInput.value.trim() : '';
          if (name) properties['Nome na camisola'] = name.toUpperCase();
          if (num)  properties['Número na camisola'] = num;
        }

        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: vid,
              quantity: 1,
              properties: properties
            })
          });
          await refreshCart();
        } catch(e) {
          console.error('[KICK.X] Cart rec add error:', e);
          addBtn.disabled = false;
          addBtn.innerHTML = originalSvg;
        }
      });
    });
  }

  // -- Init on load --
  if (document.readyState !== 'loading') {
    refreshCart();
  } else {
    document.addEventListener('DOMContentLoaded', refreshCart);
  }

  // -- Public API --
  window.kickx = window.kickx || {};
  window.kickx.refreshCart  = refreshCart;
  window.kickx.openCart     = openCart;
  window.kickx.closeCart    = closeCart;
  window.kickx.formatMoney  = formatMoney;

})();

// =============================================================================
// SOCIAL PROOF TOAST
// =============================================================================
(function() {
  const buyers = [
    { name: 'Gonçalo F.', city: 'Porto', avatar: 12 },
    { name: 'Mariana S.', city: 'Lisboa', avatar: 47 },
    { name: 'Tiago M.', city: 'Braga', avatar: 33 },
    { name: 'Beatriz C.', city: 'Coimbra', avatar: 5 },
    { name: 'Ricardo A.', city: 'Setúbal', avatar: 68 },
    { name: 'Inês P.', city: 'Faro', avatar: 44 },
    { name: 'Diogo L.', city: 'Aveiro', avatar: 15 },
    { name: 'Catarina R.', city: 'Leiria', avatar: 29 },
    { name: 'Rui V.', city: 'Funchal', avatar: 52 },
    { name: 'Ana M.', city: 'Guimarães', avatar: 9 },
    { name: 'Pedro N.', city: 'Viseu', avatar: 61 },
    { name: 'Francisca B.', city: 'Évora', avatar: 37 },
  ];

  const products = [
    'Camisola Principal 25/26',
    'Camisola Alternativa 25/26',
    'Camisola Terceira 25/26',
    'Camisola Retrô 98/99',
    'Camisola Especial Edição Limitada',
    'Camisola Away 24/25',
  ];

  const timeLabels = [
    'agora mesmo', 'há 2 min', 'há 5 min', 'há 8 min', 'há 12 min',
  ];

  function randomItem(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function createToast() {
    const el = document.createElement('div');
    el.className = 'sp-toast';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');

    const buyer = randomItem(buyers);
    const product = randomItem(products);
    const time = randomItem(timeLabels);

    el.innerHTML = `
      <img class="sp-toast__avatar"
           src="https://i.pravatar.cc/80?img=${buyer.avatar}"
           alt="" width="40" height="40" loading="lazy">
      <div class="sp-toast__body">
        <div class="sp-toast__top">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <path d="M20 6L9 17l-5-5"/>
          </svg>
          Acabou de Comprar
        </div>
        <div class="sp-toast__name">${buyer.name} <span style="font-weight:400;color:var(--color-muted)">· ${buyer.city}</span></div>
        <div class="sp-toast__detail">${product}</div>
        <div class="sp-toast__time">${time}</div>
      </div>`;

    document.body.appendChild(el);

    // Show
    requestAnimationFrame(() => {
      requestAnimationFrame(() => { el.classList.add('is-visible'); });
    });

    // Hide after 5s, then remove
    setTimeout(() => {
      el.classList.remove('is-visible');
      setTimeout(() => el.remove(), 500);
    }, 5000);
  }

  function scheduleNext() {
    // Random interval between 60s (1min) and 120s (2min)
    const delay = 60000 + Math.random() * 60000;
    setTimeout(() => {
      createToast();
      scheduleNext();
    }, delay);
  }

  // First toast after a short random delay (15-35s) so não aparece imediatamente
  setTimeout(() => {
    createToast();
    scheduleNext();
  }, 15000 + Math.random() * 20000);
})();

// =============================================================================
// FAQ ACCORDION -- smooth height animation, single open at a time
// =============================================================================
(function() {
  function initFaq(grid) {
    const items = grid.querySelectorAll('[data-faq-item]');

    function closeItem(item) {
      const btn = item.querySelector('[data-faq-btn]');
      const answer = item.querySelector('[data-faq-answer]');
      btn.setAttribute('aria-expanded', 'false');
      // animate to 0
      answer.style.height = answer.scrollHeight + 'px';
      requestAnimationFrame(() => {
        answer.style.height = '0px';
      });
    }

    function openItem(item) {
      const btn = item.querySelector('[data-faq-btn]');
      const answer = item.querySelector('[data-faq-answer]');
      btn.setAttribute('aria-expanded', 'true');
      // measure natural height then animate
      answer.style.height = '0px';
      const targetH = answer.scrollHeight;
      requestAnimationFrame(() => {
        // set to scrollHeight of inner content
        const inner = answer.querySelector('.faq-item__answer-inner');
        answer.style.height = inner.offsetHeight + 'px';
      });
      // clear fixed height after transition so it can reflow
      answer.addEventListener('transitionend', function onEnd() {
        if (btn.getAttribute('aria-expanded') === 'true') {
          answer.style.height = 'auto';
        }
        answer.removeEventListener('transitionend', onEnd);
      });
    }

    items.forEach(item => {
      const btn = item.querySelector('[data-faq-btn]');
      if (!btn) return;

      btn.addEventListener('click', () => {
        const isOpen = btn.getAttribute('aria-expanded') === 'true';

        // close all others in this grid
        items.forEach(other => {
          if (other !== item) {
            const otherBtn = other.querySelector('[data-faq-btn]');
            if (otherBtn && otherBtn.getAttribute('aria-expanded') === 'true') {
              closeItem(other);
            }
          }
        });

        // toggle clicked
        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });
  }

  // Init all FAQ grids on page
  document.querySelectorAll('[data-faq-grid]').forEach(initFaq);
})();

// =============================================================================
// MOBILE CAROUSELS -- scroll-snap + dots
// =============================================================================
(function() {
  function initCarousel(track) {
    if (!track) return;

    // Only activate on mobile
    function isMobile() { return window.innerWidth < 768; }

    const items = track.children;
    if (items.length < 2) return;

    // Wrap in a div so dots sit outside the scrollable area
    const parent = track.parentNode;
    const wrap = document.createElement('div');
    wrap.className = 'carousel-wrap';
    parent.insertBefore(wrap, track);
    wrap.appendChild(track);

    // Create dots
    const dotsEl = document.createElement('div');
    dotsEl.className = 'carousel-dots';
    for (let i = 0; i < items.length; i++) {
      const dot = document.createElement('button');
      dot.className = 'carousel-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Ir para item ' + (i + 1));
      dot.dataset.index = i;
      dot.addEventListener('click', () => {
        if (!isMobile()) return;
        items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
      dotsEl.appendChild(dot);
    }
    wrap.appendChild(dotsEl);

    // Update active dot on scroll
    let scrollTimer;
    track.addEventListener('scroll', () => {
      if (!isMobile()) return;
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const scrollLeft = track.scrollLeft;
        const trackW = track.offsetWidth;
        let closest = 0;
        let closestDist = Infinity;
        Array.from(items).forEach((item, i) => {
          const dist = Math.abs(item.offsetLeft - scrollLeft);
          if (dist < closestDist) { closestDist = dist; closest = i; }
        });
        dotsEl.querySelectorAll('.carousel-dot').forEach((dot, i) => {
          dot.classList.toggle('is-active', i === closest);
        });
      }, 50);
    }, { passive: true });
  }

  // Init both carousels
  document.querySelectorAll('.collection-list, .testimonials__grid').forEach(initCarousel);
})();

// =============================================================================
// STICKY ADD TO CART -- aparece quando o botão principal sai do viewport
// =============================================================================
(function() {
  const stickyBar = document.getElementById('sticky-atc');
  const stickyBtn = document.getElementById('sticky-atc-btn');
  if (!stickyBar || !stickyBtn) return;

  // Only on mobile
  if (window.innerWidth >= 990) return;

  const mainForm = document.querySelector('[data-product-form]');
  if (!mainForm) return;

  // Show sticky bar when main form scrolls out of view
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) {
        stickyBar.classList.add('is-visible');
        stickyBar.setAttribute('aria-hidden', 'false');
      } else {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
    },
    { threshold: 0, rootMargin: '0px 0px -80px 0px' }
  );
  observer.observe(mainForm);

  // Sticky button clicks the real submit button
  stickyBtn.addEventListener('click', () => {
    const realBtn = mainForm.querySelector('[type="submit"]');
    if (realBtn) realBtn.click();
    // Scroll to form smoothly
    mainForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();

// =============================================================================
// COOKIE CONSENT -- removido (usa-se o banner nativo do Shopify Customer Privacy)
// =============================================================================

// =============================================================================
// TRACK ORDER -- form submission
// =============================================================================
(function() {
  const form = document.getElementById('track-order-form');
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const orderNum = form.order_number.value.trim().replace(/^#/, '');
    const email = form.email.value.trim();

    if (!orderNum || !email) return;

    // Shopify customer order lookup -- works if customer accounts enabled
    // Otherwise, customer can find order via email link
    // We send them to /account/login with a hint, or to a search page
    const params = new URLSearchParams({ order: orderNum, email: email });
    // Best UX: direct customer to /account if they have an account,
    // otherwise show a message. For now, redirect to account login.
    window.location.href = `/account/login?return_url=/account/orders/${orderNum}`;
  });
})();

// =============================================================================
// VIDEO TESTIMONIALS -- modal player + carousel arrows
// =============================================================================
(function() {
  const modal = document.getElementById('video-modal');
  const player = modal?.querySelector('[data-video-player]');
  if (!modal || !player) return;

  function openVideo(src) {
    if (!src) return;
    player.src = src;
    player.muted = false;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    setTimeout(() => player.play().catch(() => {}), 80);
  }

  function closeVideo() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    player.pause();
    player.removeAttribute('src');
    player.load();
  }

  document.querySelectorAll('[data-video-trigger]').forEach(btn => {
    btn.addEventListener('click', () => openVideo(btn.dataset.videoSrc));
  });
  document.querySelectorAll('[data-close-video]').forEach(el => {
    el.addEventListener('click', closeVideo);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeVideo();
  });

  // Carousel arrows
  const scroll = document.querySelector('[data-video-scroll]');
  const prev = document.querySelector('[data-video-prev]');
  const next = document.querySelector('[data-video-next]');
  if (scroll && prev && next) {
    const step = () => {
      const card = scroll.querySelector('[data-video-card]');
      return card ? card.offsetWidth + 16 : 200;
    };
    prev.addEventListener('click', () => scroll.scrollBy({ left: -step() * 2, behavior: 'smooth' }));
    next.addEventListener('click', () => scroll.scrollBy({ left: step() * 2, behavior: 'smooth' }));
  }
})();

// =============================================================================
// COLLECTION FILTERS -- mobile drawer
// =============================================================================
(function() {
  const drawer = document.getElementById('collection-filters');
  if (!drawer) return;

  const openBtns = document.querySelectorAll('[data-open-filters]');
  const closeBtns = document.querySelectorAll('[data-close-filters]');
  const backdrop = document.querySelector('.collection-filters__backdrop');

  function open() {
    drawer.classList.add('is-open');
    backdrop?.classList.add('is-open');
    document.documentElement.classList.add('no-scroll');
  }
  function close() {
    drawer.classList.remove('is-open');
    backdrop?.classList.remove('is-open');
    document.documentElement.classList.remove('no-scroll');
  }

  openBtns.forEach(b => b.addEventListener('click', open));
  closeBtns.forEach(b => b.addEventListener('click', close));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });
})();

// =============================================================================
// NEWSLETTER POPUP -- delayed appearance, sessionStorage to avoid spam
// =============================================================================
(function() {
  const popup = document.getElementById('newsletter-popup');
  if (!popup) return;

  const storageKey = popup.dataset.storageKey || 'newsletter_popup_seen_v1';
  const delaySeconds = parseInt(popup.dataset.delay, 10) || 8;

  // Don't show if user already saw it this session
  try {
    if (sessionStorage.getItem(storageKey) === '1') return;
  } catch (e) { /* sessionStorage may be blocked */ }

  // If we landed on success state (form just submitted), open immediately
  const formState = popup.querySelector('[data-popup-state="form"]');
  const successState = popup.querySelector('[data-popup-state="success"]');
  const showSuccess = formState && formState.hasAttribute('hidden');

  function openPopup() {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    try { sessionStorage.setItem(storageKey, '1'); } catch (e) {}
  }

  function closePopup() {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
  }

  if (showSuccess) {
    openPopup();
  } else {
    setTimeout(openPopup, delaySeconds * 1000);
  }

  // Close handlers
  popup.querySelectorAll('[data-close-popup]').forEach(el => {
    el.addEventListener('click', closePopup);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
  });

  // Copy code button
  const copyBtn = popup.querySelector('[data-popup-copy]');
  const codeEl = popup.querySelector('[data-popup-code]');
  if (copyBtn && codeEl) {
    copyBtn.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(codeEl.textContent.trim());
        const original = copyBtn.textContent;
        copyBtn.textContent = '\u2713 Copiado!';
        setTimeout(() => { copyBtn.textContent = original; }, 1800);
      } catch (e) {
        // Fallback: select text
        const range = document.createRange();
        range.selectNode(codeEl);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
      }
    });
  }
})();

// =============================================================================
// DEEP POLISH -- Nike-level micro-interactions
// =============================================================================

// -- 1. ENHANCED SCROLL REVEAL ---------------------------------------------
(function() {
  if (!('IntersectionObserver' in window)) return;

  const opts = { threshold: 0.12, rootMargin: '0px 0px -40px 0px' };

  // Single elements
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('revealed');
      io.unobserve(entry.target);
    });
  }, opts);

  // Grid containers -- stagger children
  const ioGrid = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('revealed');
      ioGrid.unobserve(entry.target);
    });
  }, opts);

  document.querySelectorAll('[data-reveal]').forEach(el => io.observe(el));
  document.querySelectorAll('[data-reveal-grid]').forEach(el => ioGrid.observe(el));
})();

// -- 2. BUTTON RIPPLE EFFECT -----------------------------------------------
(function() {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.btn');
    if (!btn) return;

    const rect = btn.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height) * 1.5;
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top  - size / 2;

    const ripple = document.createElement('span');
    ripple.className = 'btn-ripple';
    ripple.style.cssText = `width:${size}px;height:${size}px;left:${x}px;top:${y}px;`;
    btn.appendChild(ripple);

    ripple.addEventListener('animationend', () => ripple.remove());
  });
})();

// -- 3. HERO PARALLAX -----------------------------------------------------
(function() {
  const hero = document.querySelector('.hero');
  const heroImg = hero && hero.querySelector('.hero__media img');
  if (!heroImg || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const scrollY = window.scrollY;
      const heroH = hero.offsetHeight;
      if (scrollY < heroH) {
        // Subtle parallax: image moves 30% of scroll speed
        heroImg.style.transform = `translateY(${scrollY * 0.3}px)`;
      }
      ticking = false;
    });
  }, { passive: true });
})();

// -- 4. HERO TITLE SPLIT -- wrap each word/line for stagger -----------------
(function() {
  const title = document.querySelector('.hero__title');
  if (!title || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Split by lines (using <br> or natural line breaks isn't reliable -- split by words)
  const text = title.textContent.trim();
  const words = text.split(/\s+/);

  // Group into lines of 2-3 words for visual effect
  const chunkSize = 2;
  title.innerHTML = '';
  for (let i = 0; i < words.length; i += chunkSize) {
    const chunk = words.slice(i, i + chunkSize).join(' ');
    const line = document.createElement('span');
    line.className = 'hero__title-line';
    line.style.setProperty('--line-index', String(i / chunkSize));
    line.textContent = chunk;
    title.appendChild(line);
    if (i + chunkSize < words.length) title.appendChild(document.createTextNode(' '));
  }
})();

// -- 5. PRODUCT CARD -- quick add on mobile tap ----------------------------
(function() {
  // On mobile, tapping the card first shows actions, second tap triggers quick view
  if (window.matchMedia('(hover: hover)').matches) return; // desktop has hover

  document.querySelectorAll('.product-card').forEach(card => {
    let tapped = false;
    card.addEventListener('click', (e) => {
      const actions = card.querySelector('.product-card__actions');
      if (!actions) return;
      if (!tapped) {
        e.preventDefault();
        tapped = true;
        card.classList.add('mobile-tapped');
        actions.style.opacity = '1';
        actions.style.transform = 'translateY(0)';
        // Auto-hide after 3s
        setTimeout(() => {
          tapped = false;
          card.classList.remove('mobile-tapped');
          actions.style.opacity = '';
          actions.style.transform = '';
        }, 3000);
      }
    });
  });
})();

// -- 6. SECTION DARK ALTERNATION -- testimonials goes dark -----------------
(function() {
  // Make testimonials section dark for visual rhythm
  const testimonials = document.querySelector('.testimonials');
  if (testimonials) {
    testimonials.classList.add('section--dark');
  }
})();

// -- 7. COUNTER ANIMATION -- numbers count up when revealed -----------------
(function() {
  const counters = document.querySelectorAll('[data-count-up]');
  if (!counters.length) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const target = parseInt(el.dataset.countUp, 10);
      const duration = 1200;
      const start = performance.now();

      function tick(now) {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        // Ease out
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(eased * target).toLocaleString('pt-PT');
        if (progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
      io.unobserve(el);
    });
  }, { threshold: 0.5 });

  counters.forEach(el => io.observe(el));
})();

// -- 8. CART DRAWER -- animate items on open -------------------------------
(function() {
  const cartToggle = document.querySelector('.cart-toggle');
  const cartDrawer = document.querySelector('.cart-drawer');
  if (!cartToggle || !cartDrawer) return;

  const originalOpen = cartToggle.onclick;
  cartToggle.addEventListener('click', () => {
    // Stagger animate cart items when drawer opens
    setTimeout(() => {
      const items = cartDrawer.querySelectorAll('.cart-item');
      items.forEach((item, i) => {
        item.style.opacity = '0';
        item.style.transform = 'translateX(16px)';
        item.style.transition = `opacity 0.3s ease ${i * 0.06}s, transform 0.3s ease ${i * 0.06}s`;
        requestAnimationFrame(() => {
          item.style.opacity = '1';
          item.style.transform = 'translateX(0)';
        });
      });
    }, 100);
  });
})();

// =============================================================================
// PRODUCT PAGE -- tabs, thumbnails, size guide modal
// =============================================================================
(function() {

  // -- PRODUCT TABS --------------------------------------------------------
  const tabContainers = document.querySelectorAll('[data-tabs]');
  tabContainers.forEach(container => {
    const btns = container.querySelectorAll('[data-tab]');
    const panels = container.querySelectorAll('[data-panel]');

    btns.forEach(btn => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.tab;
        btns.forEach(b => { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
        panels.forEach(p => p.classList.remove('is-active'));
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        const panel = container.querySelector(`[data-panel="${target}"]`);
        if (panel) panel.classList.add('is-active');
      });
    });
  });

  // -- PRODUCT MEDIA CAROUSEL (swipe + setas + dots) ---------------------
  document.querySelectorAll('[data-media-carousel]').forEach(carousel => {
    const track = carousel.querySelector('[data-media-track]');
    const items = carousel.querySelectorAll('[data-media-item], .product__media-item');
    const prevBtn = carousel.querySelector('[data-media-prev]');
    const nextBtn = carousel.querySelector('[data-media-next]');
    const dots = carousel.querySelectorAll('[data-media-dot]');
    if (!track || items.length < 2) return;

    function currentIndex() {
      const w = track.clientWidth || 1;
      return Math.round(track.scrollLeft / w);
    }

    function updateUI() {
      const idx = currentIndex();
      const last = items.length - 1;
      if (prevBtn) prevBtn.hidden = idx <= 0;
      if (nextBtn) nextBtn.hidden = idx >= last;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }

    function goTo(idx) {
      const w = track.clientWidth || 1;
      const clamped = Math.max(0, Math.min(items.length - 1, idx));
      track.scrollTo({ left: clamped * w, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex() - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex() + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    let scrollRaf = null;
    track.addEventListener('scroll', () => {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(() => { updateUI(); scrollRaf = null; });
    }, { passive: true });

    window.addEventListener('resize', updateUI);
    updateUI();
  });

  // -- SIZE GUIDE MODAL --------------------------------------------------
  const modal = document.getElementById('size-guide-modal');
  if (modal) {
    const openers = document.querySelectorAll('[data-open-size-guide]');
    const closers = document.querySelectorAll('[data-close-size-guide]');

    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('no-scroll');
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('no-scroll');
    }

    openers.forEach(el => el.addEventListener('click', openModal));
    closers.forEach(el => el.addEventListener('click', closeModal));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });
  }

})();

// =============================================================================
// SCROLL PROGRESS BAR
// =============================================================================
(function() {
  const bar = document.createElement('div');
  bar.className = 'scroll-progress';
  document.body.prepend(bar);

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const scrollTop = window.scrollY;
      const docH = document.documentElement.scrollHeight - window.innerHeight;
      const pct = docH > 0 ? (scrollTop / docH) * 100 : 0;
      bar.style.width = pct.toFixed(1) + '%';
      ticking = false;
    });
  }, { passive: true });
})();

// =============================================================================
// ADD TO CART TOAST -- aparece ao adicionar produto
// =============================================================================
(function() {
  // Create toast element
  const toast = document.createElement('div');
  toast.className = 'atc-toast';
  toast.innerHTML = `
    <div class="atc-toast__check">\u2713</div>
    <div class="atc-toast__text">
      <div class="atc-toast__label">Adicionado ao Carrinho</div>
      <div class="atc-toast__name" id="atc-toast-name"></div>
    </div>`;
  document.body.appendChild(toast);

  let hideTimer;

  function showToast(productName) {
    const nameEl = document.getElementById('atc-toast-name');
    if (nameEl) nameEl.textContent = productName || 'Produto adicionado';
    clearTimeout(hideTimer);
    toast.classList.add('is-visible');
    hideTimer = setTimeout(() => toast.classList.remove('is-visible'), 3500);
  }

  // Listen for form submissions on product forms
  document.querySelectorAll('[data-product-form]').forEach(form => {
    form.addEventListener('submit', () => {
      const title = document.querySelector('.product__title');
      showToast(title ? title.textContent.trim() : 'Produto');
    });
  });

  // Also trigger from sticky CTA
  const stickyBtn = document.getElementById('sticky-atc-btn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      const titleEl = document.querySelector('.sticky-atc__title');
      showToast(titleEl ? titleEl.textContent.trim() : 'Produto');
    });
  }
})();

// =============================================================================
// CONTENT-VISIBILITY INTERSECTION OBSERVER FIX
// Remove content-visibility: auto from sections as they enter viewport
// (prevents layout shift issues on some browsers)
// =============================================================================
(function() {
  if (!('IntersectionObserver' in window)) return;
  if (!CSS.supports('content-visibility', 'auto')) return;

  const sections = document.querySelectorAll('.section, .testimonials, .faq-section, .how-it-works, .league-cats');
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.contentVisibility = 'visible';
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '200px 0px' });

  sections.forEach(s => io.observe(s));
})();

// =============================================================================
// COUNTDOWN TIMER — hero + promo banner
// Le [data-countdown="AAAA-MM-DDTHH:MM:SS"]. Se a data ja passou, avanca
// automaticamente +3 dias ate ficar no futuro (promo rotativa de 3 em 3 dias
// — a oferta termina mesmo no fim de cada ciclo, ver desconto/preco no Shopify).
// =============================================================================
(function() {
  const els = document.querySelectorAll('[data-countdown]');
  if (!els.length) return;

  const CYCLE = 3 * 24 * 60 * 60 * 1000; // 3 dias
  const pad = n => String(n).padStart(2, '0');

  els.forEach(el => {
    const raw = el.getAttribute('data-countdown');
    if (!raw) return;

    // Parse manual para evitar inconsistencias de timezone entre browsers
    const m = raw.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/);
    if (!m) return;
    let target = new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0)).getTime();
    if (isNaN(target)) return;

    // Auto-reset de 3 em 3 dias: se ja expirou, rola para o proximo ciclo
    const now0 = Date.now();
    if (target <= now0) {
      const cyclesPassed = Math.ceil((now0 - target) / CYCLE) || 1;
      target += cyclesPassed * CYCLE;
      if (target <= now0) target += CYCLE;
    }

    const dEl = el.querySelector('[data-cd-days]');
    const hEl = el.querySelector('[data-cd-hours]');
    const mEl = el.querySelector('[data-cd-minutes]');
    const sEl = el.querySelector('[data-cd-seconds]');

    function tick() {
      let diff = target - Date.now();
      if (diff <= 0) { target += CYCLE; diff = target - Date.now(); }
      const days  = Math.floor(diff / 86400000);
      const hours = Math.floor(diff / 3600000) % 24;
      const mins  = Math.floor(diff / 60000) % 60;
      const secs  = Math.floor(diff / 1000) % 60;
      if (dEl) dEl.textContent = pad(days);
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(mins);
      if (sEl) sEl.textContent = pad(secs);
    }

    tick();
    setInterval(tick, 1000);
  });
})();

// =============================================================================
// PRODUCT CAROUSEL — setas de navegação para as secções "Coleção em Carrossel"
// Faz scroll de uma "pagina" de cartões a cada clique, e esconde a seta no
// extremo correspondente quando ja nao ha mais para onde ir.
// =============================================================================
(function() {
  const carousels = document.querySelectorAll('[data-carousel]');
  if (!carousels.length) return;

  carousels.forEach(carousel => {
    const track = carousel.querySelector('[data-carousel-track]');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');
    if (!track) return;

    function scrollAmount() {
      const item = track.querySelector('.carousel__item');
      if (!item) return track.clientWidth * 0.8;
      const itemWidth = item.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).gap) || 18;
      // Avanca o numero de cartoes que cabem na largura visivel, minimo 1
      const visible = Math.max(1, Math.floor(track.clientWidth / (itemWidth + gap)));
      return visible * (itemWidth + gap);
    }

    function updateNavState() {
      if (!prevBtn || !nextBtn) return;
      const maxScroll = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 2;
      nextBtn.disabled = track.scrollLeft >= maxScroll;
      // Se nao ha overflow nenhum, esconde as duas
      if (track.scrollWidth <= track.clientWidth + 2) {
        prevBtn.disabled = true;
        nextBtn.disabled = true;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', () => {
      window.requestAnimationFrame(updateNavState);
    }, { passive: true });

    window.addEventListener('resize', updateNavState);

    updateNavState();
  });
})();
